/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCompleteEvent = /* GraphQL */ `subscription OnCompleteEvent($executionId: ID!) {
  onCompleteEvent(executionId: $executionId) {
    executionId
    status
    result
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCompleteEventSubscriptionVariables,
  APITypes.OnCompleteEventSubscription
>;
export const onCreateAttachment = /* GraphQL */ `subscription OnCreateAttachment(
  $filter: ModelSubscriptionAttachmentFilterInput
) {
  onCreateAttachment(filter: $filter) {
    id
    type
    parentId
    parentType
    propertyId
    key
    localCreatedAtTime
    status
    imageSource
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAttachmentSubscriptionVariables,
  APITypes.OnCreateAttachmentSubscription
>;
export const onUpdateAttachment = /* GraphQL */ `subscription OnUpdateAttachment(
  $filter: ModelSubscriptionAttachmentFilterInput
) {
  onUpdateAttachment(filter: $filter) {
    id
    type
    parentId
    parentType
    propertyId
    key
    localCreatedAtTime
    status
    imageSource
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAttachmentSubscriptionVariables,
  APITypes.OnUpdateAttachmentSubscription
>;
export const onDeleteAttachment = /* GraphQL */ `subscription OnDeleteAttachment(
  $filter: ModelSubscriptionAttachmentFilterInput
) {
  onDeleteAttachment(filter: $filter) {
    id
    type
    parentId
    parentType
    propertyId
    key
    localCreatedAtTime
    status
    imageSource
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAttachmentSubscriptionVariables,
  APITypes.OnDeleteAttachmentSubscription
>;
export const onCreateBiddingContact = /* GraphQL */ `subscription OnCreateBiddingContact(
  $filter: ModelSubscriptionBiddingContactFilterInput
) {
  onCreateBiddingContact(filter: $filter) {
    id
    email
    ownerEntityId
    contactEntityId
    name
    privateDescription
    publicDescription
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBiddingContactSubscriptionVariables,
  APITypes.OnCreateBiddingContactSubscription
>;
export const onUpdateBiddingContact = /* GraphQL */ `subscription OnUpdateBiddingContact(
  $filter: ModelSubscriptionBiddingContactFilterInput
) {
  onUpdateBiddingContact(filter: $filter) {
    id
    email
    ownerEntityId
    contactEntityId
    name
    privateDescription
    publicDescription
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBiddingContactSubscriptionVariables,
  APITypes.OnUpdateBiddingContactSubscription
>;
export const onDeleteBiddingContact = /* GraphQL */ `subscription OnDeleteBiddingContact(
  $filter: ModelSubscriptionBiddingContactFilterInput
) {
  onDeleteBiddingContact(filter: $filter) {
    id
    email
    ownerEntityId
    contactEntityId
    name
    privateDescription
    publicDescription
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBiddingContactSubscriptionVariables,
  APITypes.OnDeleteBiddingContactSubscription
>;
export const onCreateBidInvitation = /* GraphQL */ `subscription OnCreateBidInvitation(
  $filter: ModelSubscriptionBidInvitationFilterInput
) {
  onCreateBidInvitation(filter: $filter) {
    id
    biddingContactId
    tenderId
    ownerEntityId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBidInvitationSubscriptionVariables,
  APITypes.OnCreateBidInvitationSubscription
>;
export const onUpdateBidInvitation = /* GraphQL */ `subscription OnUpdateBidInvitation(
  $filter: ModelSubscriptionBidInvitationFilterInput
) {
  onUpdateBidInvitation(filter: $filter) {
    id
    biddingContactId
    tenderId
    ownerEntityId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBidInvitationSubscriptionVariables,
  APITypes.OnUpdateBidInvitationSubscription
>;
export const onDeleteBidInvitation = /* GraphQL */ `subscription OnDeleteBidInvitation(
  $filter: ModelSubscriptionBidInvitationFilterInput
) {
  onDeleteBidInvitation(filter: $filter) {
    id
    biddingContactId
    tenderId
    ownerEntityId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBidInvitationSubscriptionVariables,
  APITypes.OnDeleteBidInvitationSubscription
>;
export const onCreateBid = /* GraphQL */ `subscription OnCreateBid($filter: ModelSubscriptionBidFilterInput) {
  onCreateBid(filter: $filter) {
    id
    tenderId
    latestMinorVersion
    latestAcceptedMinorVersion
    latestSubmittedMinorVersion
    status
    bidNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBidSubscriptionVariables,
  APITypes.OnCreateBidSubscription
>;
export const onUpdateBid = /* GraphQL */ `subscription OnUpdateBid($filter: ModelSubscriptionBidFilterInput) {
  onUpdateBid(filter: $filter) {
    id
    tenderId
    latestMinorVersion
    latestAcceptedMinorVersion
    latestSubmittedMinorVersion
    status
    bidNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBidSubscriptionVariables,
  APITypes.OnUpdateBidSubscription
>;
export const onDeleteBid = /* GraphQL */ `subscription OnDeleteBid($filter: ModelSubscriptionBidFilterInput) {
  onDeleteBid(filter: $filter) {
    id
    tenderId
    latestMinorVersion
    latestAcceptedMinorVersion
    latestSubmittedMinorVersion
    status
    bidNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBidSubscriptionVariables,
  APITypes.OnDeleteBidSubscription
>;
export const onCreateBidMinorVersion = /* GraphQL */ `subscription OnCreateBidMinorVersion(
  $filter: ModelSubscriptionBidMinorVersionFilterInput
) {
  onCreateBidMinorVersion(filter: $filter) {
    id
    bidId
    minorVersion
    tenderId
    tenderMinorVersion
    proposalId
    status
    metadata {
      bidderContactName
      bidderContactEmail
      bidderCompanyName
      bidderContactAddress
      bidderContactPhoneNumber
      bidderWebsite
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBidMinorVersionSubscriptionVariables,
  APITypes.OnCreateBidMinorVersionSubscription
>;
export const onUpdateBidMinorVersion = /* GraphQL */ `subscription OnUpdateBidMinorVersion(
  $filter: ModelSubscriptionBidMinorVersionFilterInput
) {
  onUpdateBidMinorVersion(filter: $filter) {
    id
    bidId
    minorVersion
    tenderId
    tenderMinorVersion
    proposalId
    status
    metadata {
      bidderContactName
      bidderContactEmail
      bidderCompanyName
      bidderContactAddress
      bidderContactPhoneNumber
      bidderWebsite
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBidMinorVersionSubscriptionVariables,
  APITypes.OnUpdateBidMinorVersionSubscription
>;
export const onDeleteBidMinorVersion = /* GraphQL */ `subscription OnDeleteBidMinorVersion(
  $filter: ModelSubscriptionBidMinorVersionFilterInput
) {
  onDeleteBidMinorVersion(filter: $filter) {
    id
    bidId
    minorVersion
    tenderId
    tenderMinorVersion
    proposalId
    status
    metadata {
      bidderContactName
      bidderContactEmail
      bidderCompanyName
      bidderContactAddress
      bidderContactPhoneNumber
      bidderWebsite
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBidMinorVersionSubscriptionVariables,
  APITypes.OnDeleteBidMinorVersionSubscription
>;
export const onCreateClientLog = /* GraphQL */ `subscription OnCreateClientLog($filter: ModelSubscriptionClientLogFilterInput) {
  onCreateClientLog(filter: $filter) {
    id
    userId
    userAgent
    severityLevel
    componentName
    message
    details
    tags
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateClientLogSubscriptionVariables,
  APITypes.OnCreateClientLogSubscription
>;
export const onUpdateClientLog = /* GraphQL */ `subscription OnUpdateClientLog($filter: ModelSubscriptionClientLogFilterInput) {
  onUpdateClientLog(filter: $filter) {
    id
    userId
    userAgent
    severityLevel
    componentName
    message
    details
    tags
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateClientLogSubscriptionVariables,
  APITypes.OnUpdateClientLogSubscription
>;
export const onDeleteClientLog = /* GraphQL */ `subscription OnDeleteClientLog($filter: ModelSubscriptionClientLogFilterInput) {
  onDeleteClientLog(filter: $filter) {
    id
    userId
    userAgent
    severityLevel
    componentName
    message
    details
    tags
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteClientLogSubscriptionVariables,
  APITypes.OnDeleteClientLogSubscription
>;
export const onCreateCounter = /* GraphQL */ `subscription OnCreateCounter($filter: ModelSubscriptionCounterFilterInput) {
  onCreateCounter(filter: $filter) {
    id
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCounterSubscriptionVariables,
  APITypes.OnCreateCounterSubscription
>;
export const onUpdateCounter = /* GraphQL */ `subscription OnUpdateCounter($filter: ModelSubscriptionCounterFilterInput) {
  onUpdateCounter(filter: $filter) {
    id
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCounterSubscriptionVariables,
  APITypes.OnUpdateCounterSubscription
>;
export const onDeleteCounter = /* GraphQL */ `subscription OnDeleteCounter($filter: ModelSubscriptionCounterFilterInput) {
  onDeleteCounter(filter: $filter) {
    id
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCounterSubscriptionVariables,
  APITypes.OnDeleteCounterSubscription
>;
export const onCreateDesignDocument = /* GraphQL */ `subscription OnCreateDesignDocument(
  $filter: ModelSubscriptionDesignDocumentFilterInput
) {
  onCreateDesignDocument(filter: $filter) {
    id
    designDocumentGroupId
    propertyId
    projectId
    name
    status
    lastEvaluatedValidityStatus
    uploadStatus
    documentKey
    lastWorkScopeSpecificationItemNumber
    version
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDesignDocumentSubscriptionVariables,
  APITypes.OnCreateDesignDocumentSubscription
>;
export const onUpdateDesignDocument = /* GraphQL */ `subscription OnUpdateDesignDocument(
  $filter: ModelSubscriptionDesignDocumentFilterInput
) {
  onUpdateDesignDocument(filter: $filter) {
    id
    designDocumentGroupId
    propertyId
    projectId
    name
    status
    lastEvaluatedValidityStatus
    uploadStatus
    documentKey
    lastWorkScopeSpecificationItemNumber
    version
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDesignDocumentSubscriptionVariables,
  APITypes.OnUpdateDesignDocumentSubscription
>;
export const onDeleteDesignDocument = /* GraphQL */ `subscription OnDeleteDesignDocument(
  $filter: ModelSubscriptionDesignDocumentFilterInput
) {
  onDeleteDesignDocument(filter: $filter) {
    id
    designDocumentGroupId
    propertyId
    projectId
    name
    status
    lastEvaluatedValidityStatus
    uploadStatus
    documentKey
    lastWorkScopeSpecificationItemNumber
    version
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDesignDocumentSubscriptionVariables,
  APITypes.OnDeleteDesignDocumentSubscription
>;
export const onCreateDesignDocumentGroup = /* GraphQL */ `subscription OnCreateDesignDocumentGroup(
  $filter: ModelSubscriptionDesignDocumentGroupFilterInput
) {
  onCreateDesignDocumentGroup(filter: $filter) {
    id
    projectId
    propertyId
    name
    latestDocumentVersion
    documentContentKey
    solutionGroupNumber
    isLocked
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDesignDocumentGroupSubscriptionVariables,
  APITypes.OnCreateDesignDocumentGroupSubscription
>;
export const onUpdateDesignDocumentGroup = /* GraphQL */ `subscription OnUpdateDesignDocumentGroup(
  $filter: ModelSubscriptionDesignDocumentGroupFilterInput
) {
  onUpdateDesignDocumentGroup(filter: $filter) {
    id
    projectId
    propertyId
    name
    latestDocumentVersion
    documentContentKey
    solutionGroupNumber
    isLocked
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDesignDocumentGroupSubscriptionVariables,
  APITypes.OnUpdateDesignDocumentGroupSubscription
>;
export const onDeleteDesignDocumentGroup = /* GraphQL */ `subscription OnDeleteDesignDocumentGroup(
  $filter: ModelSubscriptionDesignDocumentGroupFilterInput
) {
  onDeleteDesignDocumentGroup(filter: $filter) {
    id
    projectId
    propertyId
    name
    latestDocumentVersion
    documentContentKey
    solutionGroupNumber
    isLocked
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDesignDocumentGroupSubscriptionVariables,
  APITypes.OnDeleteDesignDocumentGroupSubscription
>;
export const onCreateDimension = /* GraphQL */ `subscription OnCreateDimension($filter: ModelSubscriptionDimensionFilterInput) {
  onCreateDimension(filter: $filter) {
    id
    parentId
    propertyId
    createdInSolution
    description
    length
    lengthUnit
    width
    widthUnit
    dimensionType
    measurementUnit
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDimensionSubscriptionVariables,
  APITypes.OnCreateDimensionSubscription
>;
export const onUpdateDimension = /* GraphQL */ `subscription OnUpdateDimension($filter: ModelSubscriptionDimensionFilterInput) {
  onUpdateDimension(filter: $filter) {
    id
    parentId
    propertyId
    createdInSolution
    description
    length
    lengthUnit
    width
    widthUnit
    dimensionType
    measurementUnit
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDimensionSubscriptionVariables,
  APITypes.OnUpdateDimensionSubscription
>;
export const onDeleteDimension = /* GraphQL */ `subscription OnDeleteDimension($filter: ModelSubscriptionDimensionFilterInput) {
  onDeleteDimension(filter: $filter) {
    id
    parentId
    propertyId
    createdInSolution
    description
    length
    lengthUnit
    width
    widthUnit
    dimensionType
    measurementUnit
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDimensionSubscriptionVariables,
  APITypes.OnDeleteDimensionSubscription
>;
export const onCreateDiscoverableWorkTypes = /* GraphQL */ `subscription OnCreateDiscoverableWorkTypes(
  $filter: ModelSubscriptionDiscoverableWorkTypesFilterInput
) {
  onCreateDiscoverableWorkTypes(filter: $filter) {
    id
    workTypeGroupId
    defaultVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDiscoverableWorkTypesSubscriptionVariables,
  APITypes.OnCreateDiscoverableWorkTypesSubscription
>;
export const onUpdateDiscoverableWorkTypes = /* GraphQL */ `subscription OnUpdateDiscoverableWorkTypes(
  $filter: ModelSubscriptionDiscoverableWorkTypesFilterInput
) {
  onUpdateDiscoverableWorkTypes(filter: $filter) {
    id
    workTypeGroupId
    defaultVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDiscoverableWorkTypesSubscriptionVariables,
  APITypes.OnUpdateDiscoverableWorkTypesSubscription
>;
export const onDeleteDiscoverableWorkTypes = /* GraphQL */ `subscription OnDeleteDiscoverableWorkTypes(
  $filter: ModelSubscriptionDiscoverableWorkTypesFilterInput
) {
  onDeleteDiscoverableWorkTypes(filter: $filter) {
    id
    workTypeGroupId
    defaultVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDiscoverableWorkTypesSubscriptionVariables,
  APITypes.OnDeleteDiscoverableWorkTypesSubscription
>;
export const onCreateEntityResourcePermission = /* GraphQL */ `subscription OnCreateEntityResourcePermission(
  $filter: ModelSubscriptionEntityResourcePermissionFilterInput
) {
  onCreateEntityResourcePermission(filter: $filter) {
    id
    propertyId
    entityId
    entityType
    resourceId
    resourceType
    permissionType
    isGranted
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEntityResourcePermissionSubscriptionVariables,
  APITypes.OnCreateEntityResourcePermissionSubscription
>;
export const onUpdateEntityResourcePermission = /* GraphQL */ `subscription OnUpdateEntityResourcePermission(
  $filter: ModelSubscriptionEntityResourcePermissionFilterInput
) {
  onUpdateEntityResourcePermission(filter: $filter) {
    id
    propertyId
    entityId
    entityType
    resourceId
    resourceType
    permissionType
    isGranted
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEntityResourcePermissionSubscriptionVariables,
  APITypes.OnUpdateEntityResourcePermissionSubscription
>;
export const onDeleteEntityResourcePermission = /* GraphQL */ `subscription OnDeleteEntityResourcePermission(
  $filter: ModelSubscriptionEntityResourcePermissionFilterInput
) {
  onDeleteEntityResourcePermission(filter: $filter) {
    id
    propertyId
    entityId
    entityType
    resourceId
    resourceType
    permissionType
    isGranted
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEntityResourcePermissionSubscriptionVariables,
  APITypes.OnDeleteEntityResourcePermissionSubscription
>;
export const onCreateEntityWorkTypeAssociation = /* GraphQL */ `subscription OnCreateEntityWorkTypeAssociation(
  $filter: ModelSubscriptionEntityWorkTypeAssociationFilterInput
) {
  onCreateEntityWorkTypeAssociation(filter: $filter) {
    id
    entityId
    entityType
    workTypeGroupId
    workTypeVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEntityWorkTypeAssociationSubscriptionVariables,
  APITypes.OnCreateEntityWorkTypeAssociationSubscription
>;
export const onUpdateEntityWorkTypeAssociation = /* GraphQL */ `subscription OnUpdateEntityWorkTypeAssociation(
  $filter: ModelSubscriptionEntityWorkTypeAssociationFilterInput
) {
  onUpdateEntityWorkTypeAssociation(filter: $filter) {
    id
    entityId
    entityType
    workTypeGroupId
    workTypeVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEntityWorkTypeAssociationSubscriptionVariables,
  APITypes.OnUpdateEntityWorkTypeAssociationSubscription
>;
export const onDeleteEntityWorkTypeAssociation = /* GraphQL */ `subscription OnDeleteEntityWorkTypeAssociation(
  $filter: ModelSubscriptionEntityWorkTypeAssociationFilterInput
) {
  onDeleteEntityWorkTypeAssociation(filter: $filter) {
    id
    entityId
    entityType
    workTypeGroupId
    workTypeVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEntityWorkTypeAssociationSubscriptionVariables,
  APITypes.OnDeleteEntityWorkTypeAssociationSubscription
>;
export const onCreateInspection = /* GraphQL */ `subscription OnCreateInspection(
  $filter: ModelSubscriptionInspectionFilterInput
) {
  onCreateInspection(filter: $filter) {
    id
    propertyId
    createdByOrganizationId
    createdByUserId
    startTime
    endTime
    status
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateInspectionSubscriptionVariables,
  APITypes.OnCreateInspectionSubscription
>;
export const onUpdateInspection = /* GraphQL */ `subscription OnUpdateInspection(
  $filter: ModelSubscriptionInspectionFilterInput
) {
  onUpdateInspection(filter: $filter) {
    id
    propertyId
    createdByOrganizationId
    createdByUserId
    startTime
    endTime
    status
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateInspectionSubscriptionVariables,
  APITypes.OnUpdateInspectionSubscription
>;
export const onDeleteInspection = /* GraphQL */ `subscription OnDeleteInspection(
  $filter: ModelSubscriptionInspectionFilterInput
) {
  onDeleteInspection(filter: $filter) {
    id
    propertyId
    createdByOrganizationId
    createdByUserId
    startTime
    endTime
    status
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteInspectionSubscriptionVariables,
  APITypes.OnDeleteInspectionSubscription
>;
export const onCreateIssue = /* GraphQL */ `subscription OnCreateIssue($filter: ModelSubscriptionIssueFilterInput) {
  onCreateIssue(filter: $filter) {
    id
    locationId
    propertyId
    inspectionId
    createdInSolution
    name
    description
    note
    tags
    tagIds
    status
    clientCreationDate
    localLastUpdatedTime
    createdBy
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    canViewList
    canViewEntityVersionMap
    isPubliclySubmitted
    suggestedWorkTypeIds
    quickQuoteIds
    proposalDocLinks {
      name
      link
      date
      __typename
    }
    priority
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateIssueSubscriptionVariables,
  APITypes.OnCreateIssueSubscription
>;
export const onUpdateIssue = /* GraphQL */ `subscription OnUpdateIssue($filter: ModelSubscriptionIssueFilterInput) {
  onUpdateIssue(filter: $filter) {
    id
    locationId
    propertyId
    inspectionId
    createdInSolution
    name
    description
    note
    tags
    tagIds
    status
    clientCreationDate
    localLastUpdatedTime
    createdBy
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    canViewList
    canViewEntityVersionMap
    isPubliclySubmitted
    suggestedWorkTypeIds
    quickQuoteIds
    proposalDocLinks {
      name
      link
      date
      __typename
    }
    priority
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateIssueSubscriptionVariables,
  APITypes.OnUpdateIssueSubscription
>;
export const onDeleteIssue = /* GraphQL */ `subscription OnDeleteIssue($filter: ModelSubscriptionIssueFilterInput) {
  onDeleteIssue(filter: $filter) {
    id
    locationId
    propertyId
    inspectionId
    createdInSolution
    name
    description
    note
    tags
    tagIds
    status
    clientCreationDate
    localLastUpdatedTime
    createdBy
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    canViewList
    canViewEntityVersionMap
    isPubliclySubmitted
    suggestedWorkTypeIds
    quickQuoteIds
    proposalDocLinks {
      name
      link
      date
      __typename
    }
    priority
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteIssueSubscriptionVariables,
  APITypes.OnDeleteIssueSubscription
>;
export const onCreateQuickQuote = /* GraphQL */ `subscription OnCreateQuickQuote(
  $filter: ModelSubscriptionQuickQuoteFilterInput
) {
  onCreateQuickQuote(filter: $filter) {
    id
    propertyId
    generatedProposalId
    status
    generatedSolutionId
    issueIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateQuickQuoteSubscriptionVariables,
  APITypes.OnCreateQuickQuoteSubscription
>;
export const onUpdateQuickQuote = /* GraphQL */ `subscription OnUpdateQuickQuote(
  $filter: ModelSubscriptionQuickQuoteFilterInput
) {
  onUpdateQuickQuote(filter: $filter) {
    id
    propertyId
    generatedProposalId
    status
    generatedSolutionId
    issueIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateQuickQuoteSubscriptionVariables,
  APITypes.OnUpdateQuickQuoteSubscription
>;
export const onDeleteQuickQuote = /* GraphQL */ `subscription OnDeleteQuickQuote(
  $filter: ModelSubscriptionQuickQuoteFilterInput
) {
  onDeleteQuickQuote(filter: $filter) {
    id
    propertyId
    generatedProposalId
    status
    generatedSolutionId
    issueIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteQuickQuoteSubscriptionVariables,
  APITypes.OnDeleteQuickQuoteSubscription
>;
export const onCreateLocation = /* GraphQL */ `subscription OnCreateLocation($filter: ModelSubscriptionLocationFilterInput) {
  onCreateLocation(filter: $filter) {
    id
    propertyId
    createdInSolution
    name
    tags
    localCreationTime
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLocationSubscriptionVariables,
  APITypes.OnCreateLocationSubscription
>;
export const onUpdateLocation = /* GraphQL */ `subscription OnUpdateLocation($filter: ModelSubscriptionLocationFilterInput) {
  onUpdateLocation(filter: $filter) {
    id
    propertyId
    createdInSolution
    name
    tags
    localCreationTime
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLocationSubscriptionVariables,
  APITypes.OnUpdateLocationSubscription
>;
export const onDeleteLocation = /* GraphQL */ `subscription OnDeleteLocation($filter: ModelSubscriptionLocationFilterInput) {
  onDeleteLocation(filter: $filter) {
    id
    propertyId
    createdInSolution
    name
    tags
    localCreationTime
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLocationSubscriptionVariables,
  APITypes.OnDeleteLocationSubscription
>;
export const onCreateNote = /* GraphQL */ `subscription OnCreateNote($filter: ModelSubscriptionNoteFilterInput) {
  onCreateNote(filter: $filter) {
    id
    parentId
    propertyId
    note
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateNoteSubscriptionVariables,
  APITypes.OnCreateNoteSubscription
>;
export const onUpdateNote = /* GraphQL */ `subscription OnUpdateNote($filter: ModelSubscriptionNoteFilterInput) {
  onUpdateNote(filter: $filter) {
    id
    parentId
    propertyId
    note
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateNoteSubscriptionVariables,
  APITypes.OnUpdateNoteSubscription
>;
export const onDeleteNote = /* GraphQL */ `subscription OnDeleteNote($filter: ModelSubscriptionNoteFilterInput) {
  onDeleteNote(filter: $filter) {
    id
    parentId
    propertyId
    note
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteNoteSubscriptionVariables,
  APITypes.OnDeleteNoteSubscription
>;
export const onCreateOrganization = /* GraphQL */ `subscription OnCreateOrganization(
  $filter: ModelSubscriptionOrganizationFilterInput
) {
  onCreateOrganization(filter: $filter) {
    id
    legalName
    type
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOrganizationSubscriptionVariables,
  APITypes.OnCreateOrganizationSubscription
>;
export const onUpdateOrganization = /* GraphQL */ `subscription OnUpdateOrganization(
  $filter: ModelSubscriptionOrganizationFilterInput
) {
  onUpdateOrganization(filter: $filter) {
    id
    legalName
    type
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOrganizationSubscriptionVariables,
  APITypes.OnUpdateOrganizationSubscription
>;
export const onDeleteOrganization = /* GraphQL */ `subscription OnDeleteOrganization(
  $filter: ModelSubscriptionOrganizationFilterInput
) {
  onDeleteOrganization(filter: $filter) {
    id
    legalName
    type
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOrganizationSubscriptionVariables,
  APITypes.OnDeleteOrganizationSubscription
>;
export const onCreateOrganizationBillingProfile = /* GraphQL */ `subscription OnCreateOrganizationBillingProfile(
  $filter: ModelSubscriptionOrganizationBillingProfileFilterInput
) {
  onCreateOrganizationBillingProfile(filter: $filter) {
    organizationId
    billingProfileId
    billingProvider
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOrganizationBillingProfileSubscriptionVariables,
  APITypes.OnCreateOrganizationBillingProfileSubscription
>;
export const onUpdateOrganizationBillingProfile = /* GraphQL */ `subscription OnUpdateOrganizationBillingProfile(
  $filter: ModelSubscriptionOrganizationBillingProfileFilterInput
) {
  onUpdateOrganizationBillingProfile(filter: $filter) {
    organizationId
    billingProfileId
    billingProvider
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOrganizationBillingProfileSubscriptionVariables,
  APITypes.OnUpdateOrganizationBillingProfileSubscription
>;
export const onDeleteOrganizationBillingProfile = /* GraphQL */ `subscription OnDeleteOrganizationBillingProfile(
  $filter: ModelSubscriptionOrganizationBillingProfileFilterInput
) {
  onDeleteOrganizationBillingProfile(filter: $filter) {
    organizationId
    billingProfileId
    billingProvider
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOrganizationBillingProfileSubscriptionVariables,
  APITypes.OnDeleteOrganizationBillingProfileSubscription
>;
export const onCreateTeam = /* GraphQL */ `subscription OnCreateTeam($filter: ModelSubscriptionTeamFilterInput) {
  onCreateTeam(filter: $filter) {
    id
    organizationId
    type
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTeamSubscriptionVariables,
  APITypes.OnCreateTeamSubscription
>;
export const onUpdateTeam = /* GraphQL */ `subscription OnUpdateTeam($filter: ModelSubscriptionTeamFilterInput) {
  onUpdateTeam(filter: $filter) {
    id
    organizationId
    type
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTeamSubscriptionVariables,
  APITypes.OnUpdateTeamSubscription
>;
export const onDeleteTeam = /* GraphQL */ `subscription OnDeleteTeam($filter: ModelSubscriptionTeamFilterInput) {
  onDeleteTeam(filter: $filter) {
    id
    organizationId
    type
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTeamSubscriptionVariables,
  APITypes.OnDeleteTeamSubscription
>;
export const onCreateTeamMember = /* GraphQL */ `subscription OnCreateTeamMember(
  $filter: ModelSubscriptionTeamMemberFilterInput
) {
  onCreateTeamMember(filter: $filter) {
    id
    teamId
    organizationId
    userId
    joinedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTeamMemberSubscriptionVariables,
  APITypes.OnCreateTeamMemberSubscription
>;
export const onUpdateTeamMember = /* GraphQL */ `subscription OnUpdateTeamMember(
  $filter: ModelSubscriptionTeamMemberFilterInput
) {
  onUpdateTeamMember(filter: $filter) {
    id
    teamId
    organizationId
    userId
    joinedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTeamMemberSubscriptionVariables,
  APITypes.OnUpdateTeamMemberSubscription
>;
export const onDeleteTeamMember = /* GraphQL */ `subscription OnDeleteTeamMember(
  $filter: ModelSubscriptionTeamMemberFilterInput
) {
  onDeleteTeamMember(filter: $filter) {
    id
    teamId
    organizationId
    userId
    joinedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTeamMemberSubscriptionVariables,
  APITypes.OnDeleteTeamMemberSubscription
>;
export const onCreateAccountInvitation = /* GraphQL */ `subscription OnCreateAccountInvitation(
  $filter: ModelSubscriptionAccountInvitationFilterInput
) {
  onCreateAccountInvitation(filter: $filter) {
    id
    organizationId
    role
    email
    expiresAt
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAccountInvitationSubscriptionVariables,
  APITypes.OnCreateAccountInvitationSubscription
>;
export const onUpdateAccountInvitation = /* GraphQL */ `subscription OnUpdateAccountInvitation(
  $filter: ModelSubscriptionAccountInvitationFilterInput
) {
  onUpdateAccountInvitation(filter: $filter) {
    id
    organizationId
    role
    email
    expiresAt
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAccountInvitationSubscriptionVariables,
  APITypes.OnUpdateAccountInvitationSubscription
>;
export const onDeleteAccountInvitation = /* GraphQL */ `subscription OnDeleteAccountInvitation(
  $filter: ModelSubscriptionAccountInvitationFilterInput
) {
  onDeleteAccountInvitation(filter: $filter) {
    id
    organizationId
    role
    email
    expiresAt
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAccountInvitationSubscriptionVariables,
  APITypes.OnDeleteAccountInvitationSubscription
>;
export const onCreateProject = /* GraphQL */ `subscription OnCreateProject($filter: ModelSubscriptionProjectFilterInput) {
  onCreateProject(filter: $filter) {
    id
    propertyId
    name
    tenderNumber
    customer
    address
    propertyType
    dueDate
    contactName
    contactNumber
    contactEmail
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProjectSubscriptionVariables,
  APITypes.OnCreateProjectSubscription
>;
export const onUpdateProject = /* GraphQL */ `subscription OnUpdateProject($filter: ModelSubscriptionProjectFilterInput) {
  onUpdateProject(filter: $filter) {
    id
    propertyId
    name
    tenderNumber
    customer
    address
    propertyType
    dueDate
    contactName
    contactNumber
    contactEmail
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProjectSubscriptionVariables,
  APITypes.OnUpdateProjectSubscription
>;
export const onDeleteProject = /* GraphQL */ `subscription OnDeleteProject($filter: ModelSubscriptionProjectFilterInput) {
  onDeleteProject(filter: $filter) {
    id
    propertyId
    name
    tenderNumber
    customer
    address
    propertyType
    dueDate
    contactName
    contactNumber
    contactEmail
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProjectSubscriptionVariables,
  APITypes.OnDeleteProjectSubscription
>;
export const onCreateProjectCounter = /* GraphQL */ `subscription OnCreateProjectCounter(
  $filter: ModelSubscriptionProjectCounterFilterInput
) {
  onCreateProjectCounter(filter: $filter) {
    id
    propertyId
    latestProjectNumber
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProjectCounterSubscriptionVariables,
  APITypes.OnCreateProjectCounterSubscription
>;
export const onUpdateProjectCounter = /* GraphQL */ `subscription OnUpdateProjectCounter(
  $filter: ModelSubscriptionProjectCounterFilterInput
) {
  onUpdateProjectCounter(filter: $filter) {
    id
    propertyId
    latestProjectNumber
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProjectCounterSubscriptionVariables,
  APITypes.OnUpdateProjectCounterSubscription
>;
export const onDeleteProjectCounter = /* GraphQL */ `subscription OnDeleteProjectCounter(
  $filter: ModelSubscriptionProjectCounterFilterInput
) {
  onDeleteProjectCounter(filter: $filter) {
    id
    propertyId
    latestProjectNumber
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProjectCounterSubscriptionVariables,
  APITypes.OnDeleteProjectCounterSubscription
>;
export const onCreateProperty = /* GraphQL */ `subscription OnCreateProperty($filter: ModelSubscriptionPropertyFilterInput) {
  onCreateProperty(filter: $filter) {
    id
    name
    description
    address
    ownerOrganizationId
    primaryContactNumber
    primaryContactEmail
    primaryContactName
    propertyNumber
    locations {
      items {
        id
        propertyId
        createdInSolution
        name
        tags
        localCreationTime
        localLastUpdatedTime
        opaqueSyncReconciliationToken
        canView
        canEdit
        canDelete
        createdBy
        canViewList
        canViewEntityVersionMap
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdBy
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    autoDashboardRebuild
    canView
    canEdit
    canCreateSolutions
    canDelete
    canViewList
    canViewEntityVersionMap
    isTestProperty
    isArchived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePropertySubscriptionVariables,
  APITypes.OnCreatePropertySubscription
>;
export const onUpdateProperty = /* GraphQL */ `subscription OnUpdateProperty($filter: ModelSubscriptionPropertyFilterInput) {
  onUpdateProperty(filter: $filter) {
    id
    name
    description
    address
    ownerOrganizationId
    primaryContactNumber
    primaryContactEmail
    primaryContactName
    propertyNumber
    locations {
      items {
        id
        propertyId
        createdInSolution
        name
        tags
        localCreationTime
        localLastUpdatedTime
        opaqueSyncReconciliationToken
        canView
        canEdit
        canDelete
        createdBy
        canViewList
        canViewEntityVersionMap
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdBy
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    autoDashboardRebuild
    canView
    canEdit
    canCreateSolutions
    canDelete
    canViewList
    canViewEntityVersionMap
    isTestProperty
    isArchived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePropertySubscriptionVariables,
  APITypes.OnUpdatePropertySubscription
>;
export const onDeleteProperty = /* GraphQL */ `subscription OnDeleteProperty($filter: ModelSubscriptionPropertyFilterInput) {
  onDeleteProperty(filter: $filter) {
    id
    name
    description
    address
    ownerOrganizationId
    primaryContactNumber
    primaryContactEmail
    primaryContactName
    propertyNumber
    locations {
      items {
        id
        propertyId
        createdInSolution
        name
        tags
        localCreationTime
        localLastUpdatedTime
        opaqueSyncReconciliationToken
        canView
        canEdit
        canDelete
        createdBy
        canViewList
        canViewEntityVersionMap
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdBy
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    autoDashboardRebuild
    canView
    canEdit
    canCreateSolutions
    canDelete
    canViewList
    canViewEntityVersionMap
    isTestProperty
    isArchived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePropertySubscriptionVariables,
  APITypes.OnDeletePropertySubscription
>;
export const onCreatePropertyCounter = /* GraphQL */ `subscription OnCreatePropertyCounter(
  $filter: ModelSubscriptionPropertyCounterFilterInput
) {
  onCreatePropertyCounter(filter: $filter) {
    id
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePropertyCounterSubscriptionVariables,
  APITypes.OnCreatePropertyCounterSubscription
>;
export const onUpdatePropertyCounter = /* GraphQL */ `subscription OnUpdatePropertyCounter(
  $filter: ModelSubscriptionPropertyCounterFilterInput
) {
  onUpdatePropertyCounter(filter: $filter) {
    id
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePropertyCounterSubscriptionVariables,
  APITypes.OnUpdatePropertyCounterSubscription
>;
export const onDeletePropertyCounter = /* GraphQL */ `subscription OnDeletePropertyCounter(
  $filter: ModelSubscriptionPropertyCounterFilterInput
) {
  onDeletePropertyCounter(filter: $filter) {
    id
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePropertyCounterSubscriptionVariables,
  APITypes.OnDeletePropertyCounterSubscription
>;
export const onCreateProposal = /* GraphQL */ `subscription OnCreateProposal($filter: ModelSubscriptionProposalFilterInput) {
  onCreateProposal(filter: $filter) {
    id
    schemaVersion
    designDocumentGroupId
    designDocumentVersion
    proposalKey
    proposalNumber
    status
    author
    createdAt
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    quickQuoteId
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProposalSubscriptionVariables,
  APITypes.OnCreateProposalSubscription
>;
export const onUpdateProposal = /* GraphQL */ `subscription OnUpdateProposal($filter: ModelSubscriptionProposalFilterInput) {
  onUpdateProposal(filter: $filter) {
    id
    schemaVersion
    designDocumentGroupId
    designDocumentVersion
    proposalKey
    proposalNumber
    status
    author
    createdAt
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    quickQuoteId
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProposalSubscriptionVariables,
  APITypes.OnUpdateProposalSubscription
>;
export const onDeleteProposal = /* GraphQL */ `subscription OnDeleteProposal($filter: ModelSubscriptionProposalFilterInput) {
  onDeleteProposal(filter: $filter) {
    id
    schemaVersion
    designDocumentGroupId
    designDocumentVersion
    proposalKey
    proposalNumber
    status
    author
    createdAt
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    quickQuoteId
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProposalSubscriptionVariables,
  APITypes.OnDeleteProposalSubscription
>;
export const onCreateProposalCounter = /* GraphQL */ `subscription OnCreateProposalCounter(
  $filter: ModelSubscriptionProposalCounterFilterInput
) {
  onCreateProposalCounter(filter: $filter) {
    id
    solutionGroupId
    solutionVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProposalCounterSubscriptionVariables,
  APITypes.OnCreateProposalCounterSubscription
>;
export const onUpdateProposalCounter = /* GraphQL */ `subscription OnUpdateProposalCounter(
  $filter: ModelSubscriptionProposalCounterFilterInput
) {
  onUpdateProposalCounter(filter: $filter) {
    id
    solutionGroupId
    solutionVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProposalCounterSubscriptionVariables,
  APITypes.OnUpdateProposalCounterSubscription
>;
export const onDeleteProposalCounter = /* GraphQL */ `subscription OnDeleteProposalCounter(
  $filter: ModelSubscriptionProposalCounterFilterInput
) {
  onDeleteProposalCounter(filter: $filter) {
    id
    solutionGroupId
    solutionVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProposalCounterSubscriptionVariables,
  APITypes.OnDeleteProposalCounterSubscription
>;
export const onCreateResourceUserPermissions = /* GraphQL */ `subscription OnCreateResourceUserPermissions(
  $filter: ModelSubscriptionResourceUserPermissionsFilterInput
) {
  onCreateResourceUserPermissions(filter: $filter) {
    id
    resourceId
    userId
    userEmail
    userFullName
    resourceAndUserId
    permissions
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateResourceUserPermissionsSubscriptionVariables,
  APITypes.OnCreateResourceUserPermissionsSubscription
>;
export const onUpdateResourceUserPermissions = /* GraphQL */ `subscription OnUpdateResourceUserPermissions(
  $filter: ModelSubscriptionResourceUserPermissionsFilterInput
) {
  onUpdateResourceUserPermissions(filter: $filter) {
    id
    resourceId
    userId
    userEmail
    userFullName
    resourceAndUserId
    permissions
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateResourceUserPermissionsSubscriptionVariables,
  APITypes.OnUpdateResourceUserPermissionsSubscription
>;
export const onDeleteResourceUserPermissions = /* GraphQL */ `subscription OnDeleteResourceUserPermissions(
  $filter: ModelSubscriptionResourceUserPermissionsFilterInput
) {
  onDeleteResourceUserPermissions(filter: $filter) {
    id
    resourceId
    userId
    userEmail
    userFullName
    resourceAndUserId
    permissions
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteResourceUserPermissionsSubscriptionVariables,
  APITypes.OnDeleteResourceUserPermissionsSubscription
>;
export const onCreateSolution = /* GraphQL */ `subscription OnCreateSolution($filter: ModelSubscriptionSolutionFilterInput) {
  onCreateSolution(filter: $filter) {
    id
    propertyId
    projectId
    name
    status
    latestMinorVersion
    latestContentKey
    serialNumber
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      tenderingType
      warranty
      __typename
    }
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSolutionSubscriptionVariables,
  APITypes.OnCreateSolutionSubscription
>;
export const onUpdateSolution = /* GraphQL */ `subscription OnUpdateSolution($filter: ModelSubscriptionSolutionFilterInput) {
  onUpdateSolution(filter: $filter) {
    id
    propertyId
    projectId
    name
    status
    latestMinorVersion
    latestContentKey
    serialNumber
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      tenderingType
      warranty
      __typename
    }
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSolutionSubscriptionVariables,
  APITypes.OnUpdateSolutionSubscription
>;
export const onDeleteSolution = /* GraphQL */ `subscription OnDeleteSolution($filter: ModelSubscriptionSolutionFilterInput) {
  onDeleteSolution(filter: $filter) {
    id
    propertyId
    projectId
    name
    status
    latestMinorVersion
    latestContentKey
    serialNumber
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      tenderingType
      warranty
      __typename
    }
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSolutionSubscriptionVariables,
  APITypes.OnDeleteSolutionSubscription
>;
export const onCreateSolutionMinorVersion = /* GraphQL */ `subscription OnCreateSolutionMinorVersion(
  $filter: ModelSubscriptionSolutionMinorVersionFilterInput
) {
  onCreateSolutionMinorVersion(filter: $filter) {
    id
    solutionId
    propertyId
    name
    contentKey
    minorVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSolutionMinorVersionSubscriptionVariables,
  APITypes.OnCreateSolutionMinorVersionSubscription
>;
export const onUpdateSolutionMinorVersion = /* GraphQL */ `subscription OnUpdateSolutionMinorVersion(
  $filter: ModelSubscriptionSolutionMinorVersionFilterInput
) {
  onUpdateSolutionMinorVersion(filter: $filter) {
    id
    solutionId
    propertyId
    name
    contentKey
    minorVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSolutionMinorVersionSubscriptionVariables,
  APITypes.OnUpdateSolutionMinorVersionSubscription
>;
export const onDeleteSolutionMinorVersion = /* GraphQL */ `subscription OnDeleteSolutionMinorVersion(
  $filter: ModelSubscriptionSolutionMinorVersionFilterInput
) {
  onDeleteSolutionMinorVersion(filter: $filter) {
    id
    solutionId
    propertyId
    name
    contentKey
    minorVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSolutionMinorVersionSubscriptionVariables,
  APITypes.OnDeleteSolutionMinorVersionSubscription
>;
export const onCreateSolutionGroupCounter = /* GraphQL */ `subscription OnCreateSolutionGroupCounter(
  $filter: ModelSubscriptionSolutionGroupCounterFilterInput
) {
  onCreateSolutionGroupCounter(filter: $filter) {
    id
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSolutionGroupCounterSubscriptionVariables,
  APITypes.OnCreateSolutionGroupCounterSubscription
>;
export const onUpdateSolutionGroupCounter = /* GraphQL */ `subscription OnUpdateSolutionGroupCounter(
  $filter: ModelSubscriptionSolutionGroupCounterFilterInput
) {
  onUpdateSolutionGroupCounter(filter: $filter) {
    id
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSolutionGroupCounterSubscriptionVariables,
  APITypes.OnUpdateSolutionGroupCounterSubscription
>;
export const onDeleteSolutionGroupCounter = /* GraphQL */ `subscription OnDeleteSolutionGroupCounter(
  $filter: ModelSubscriptionSolutionGroupCounterFilterInput
) {
  onDeleteSolutionGroupCounter(filter: $filter) {
    id
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSolutionGroupCounterSubscriptionVariables,
  APITypes.OnDeleteSolutionGroupCounterSubscription
>;
export const onCreateUserGroup = /* GraphQL */ `subscription OnCreateUserGroup($filter: ModelSubscriptionUserGroupFilterInput) {
  onCreateUserGroup(filter: $filter) {
    id
    resourceId
    groupType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserGroupSubscriptionVariables,
  APITypes.OnCreateUserGroupSubscription
>;
export const onUpdateUserGroup = /* GraphQL */ `subscription OnUpdateUserGroup($filter: ModelSubscriptionUserGroupFilterInput) {
  onUpdateUserGroup(filter: $filter) {
    id
    resourceId
    groupType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserGroupSubscriptionVariables,
  APITypes.OnUpdateUserGroupSubscription
>;
export const onDeleteUserGroup = /* GraphQL */ `subscription OnDeleteUserGroup($filter: ModelSubscriptionUserGroupFilterInput) {
  onDeleteUserGroup(filter: $filter) {
    id
    resourceId
    groupType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserGroupSubscriptionVariables,
  APITypes.OnDeleteUserGroupSubscription
>;
export const onCreateUserGroupMember = /* GraphQL */ `subscription OnCreateUserGroupMember(
  $filter: ModelSubscriptionUserGroupMemberFilterInput
) {
  onCreateUserGroupMember(filter: $filter) {
    id
    resourceId
    resourceAndUserId
    userId
    userGroupId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserGroupMemberSubscriptionVariables,
  APITypes.OnCreateUserGroupMemberSubscription
>;
export const onUpdateUserGroupMember = /* GraphQL */ `subscription OnUpdateUserGroupMember(
  $filter: ModelSubscriptionUserGroupMemberFilterInput
) {
  onUpdateUserGroupMember(filter: $filter) {
    id
    resourceId
    resourceAndUserId
    userId
    userGroupId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserGroupMemberSubscriptionVariables,
  APITypes.OnUpdateUserGroupMemberSubscription
>;
export const onDeleteUserGroupMember = /* GraphQL */ `subscription OnDeleteUserGroupMember(
  $filter: ModelSubscriptionUserGroupMemberFilterInput
) {
  onDeleteUserGroupMember(filter: $filter) {
    id
    resourceId
    resourceAndUserId
    userId
    userGroupId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserGroupMemberSubscriptionVariables,
  APITypes.OnDeleteUserGroupMemberSubscription
>;
export const onCreateUserOrganizationAssociation = /* GraphQL */ `subscription OnCreateUserOrganizationAssociation(
  $filter: ModelSubscriptionUserOrganizationAssociationFilterInput
) {
  onCreateUserOrganizationAssociation(filter: $filter) {
    id
    userId
    organizationId
    associationType
    permissions
    role
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserOrganizationAssociationSubscriptionVariables,
  APITypes.OnCreateUserOrganizationAssociationSubscription
>;
export const onUpdateUserOrganizationAssociation = /* GraphQL */ `subscription OnUpdateUserOrganizationAssociation(
  $filter: ModelSubscriptionUserOrganizationAssociationFilterInput
) {
  onUpdateUserOrganizationAssociation(filter: $filter) {
    id
    userId
    organizationId
    associationType
    permissions
    role
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserOrganizationAssociationSubscriptionVariables,
  APITypes.OnUpdateUserOrganizationAssociationSubscription
>;
export const onDeleteUserOrganizationAssociation = /* GraphQL */ `subscription OnDeleteUserOrganizationAssociation(
  $filter: ModelSubscriptionUserOrganizationAssociationFilterInput
) {
  onDeleteUserOrganizationAssociation(filter: $filter) {
    id
    userId
    organizationId
    associationType
    permissions
    role
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserOrganizationAssociationSubscriptionVariables,
  APITypes.OnDeleteUserOrganizationAssociationSubscription
>;
export const onCreateWorkSpecification = /* GraphQL */ `subscription OnCreateWorkSpecification(
  $filter: ModelSubscriptionWorkSpecificationFilterInput
) {
  onCreateWorkSpecification(filter: $filter) {
    id
    dimensionId
    issueId
    propertyId
    createdInSolution
    body
    description
    workTypeId
    itemNumber
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    version
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWorkSpecificationSubscriptionVariables,
  APITypes.OnCreateWorkSpecificationSubscription
>;
export const onUpdateWorkSpecification = /* GraphQL */ `subscription OnUpdateWorkSpecification(
  $filter: ModelSubscriptionWorkSpecificationFilterInput
) {
  onUpdateWorkSpecification(filter: $filter) {
    id
    dimensionId
    issueId
    propertyId
    createdInSolution
    body
    description
    workTypeId
    itemNumber
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    version
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWorkSpecificationSubscriptionVariables,
  APITypes.OnUpdateWorkSpecificationSubscription
>;
export const onDeleteWorkSpecification = /* GraphQL */ `subscription OnDeleteWorkSpecification(
  $filter: ModelSubscriptionWorkSpecificationFilterInput
) {
  onDeleteWorkSpecification(filter: $filter) {
    id
    dimensionId
    issueId
    propertyId
    createdInSolution
    body
    description
    workTypeId
    itemNumber
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    version
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWorkSpecificationSubscriptionVariables,
  APITypes.OnDeleteWorkSpecificationSubscription
>;
export const onCreateWorkType = /* GraphQL */ `subscription OnCreateWorkType($filter: ModelSubscriptionWorkTypeFilterInput) {
  onCreateWorkType(filter: $filter) {
    id
    name
    shortDescription
    longDescription
    groupName
    unitPrice
    unitCost
    dimensionType
    measurementUnit
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWorkTypeSubscriptionVariables,
  APITypes.OnCreateWorkTypeSubscription
>;
export const onUpdateWorkType = /* GraphQL */ `subscription OnUpdateWorkType($filter: ModelSubscriptionWorkTypeFilterInput) {
  onUpdateWorkType(filter: $filter) {
    id
    name
    shortDescription
    longDescription
    groupName
    unitPrice
    unitCost
    dimensionType
    measurementUnit
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWorkTypeSubscriptionVariables,
  APITypes.OnUpdateWorkTypeSubscription
>;
export const onDeleteWorkType = /* GraphQL */ `subscription OnDeleteWorkType($filter: ModelSubscriptionWorkTypeFilterInput) {
  onDeleteWorkType(filter: $filter) {
    id
    name
    shortDescription
    longDescription
    groupName
    unitPrice
    unitCost
    dimensionType
    measurementUnit
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWorkTypeSubscriptionVariables,
  APITypes.OnDeleteWorkTypeSubscription
>;
export const onCreateWorkTypeGroup = /* GraphQL */ `subscription OnCreateWorkTypeGroup(
  $filter: ModelSubscriptionWorkTypeGroupFilterInput
) {
  onCreateWorkTypeGroup(filter: $filter) {
    id
    latestWorkTypeVersion
    environmentAgnosticWorkTypeGroupId
    isDiscoverable
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWorkTypeGroupSubscriptionVariables,
  APITypes.OnCreateWorkTypeGroupSubscription
>;
export const onUpdateWorkTypeGroup = /* GraphQL */ `subscription OnUpdateWorkTypeGroup(
  $filter: ModelSubscriptionWorkTypeGroupFilterInput
) {
  onUpdateWorkTypeGroup(filter: $filter) {
    id
    latestWorkTypeVersion
    environmentAgnosticWorkTypeGroupId
    isDiscoverable
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWorkTypeGroupSubscriptionVariables,
  APITypes.OnUpdateWorkTypeGroupSubscription
>;
export const onDeleteWorkTypeGroup = /* GraphQL */ `subscription OnDeleteWorkTypeGroup(
  $filter: ModelSubscriptionWorkTypeGroupFilterInput
) {
  onDeleteWorkTypeGroup(filter: $filter) {
    id
    latestWorkTypeVersion
    environmentAgnosticWorkTypeGroupId
    isDiscoverable
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWorkTypeGroupSubscriptionVariables,
  APITypes.OnDeleteWorkTypeGroupSubscription
>;
export const onCreateWorkTypePricing = /* GraphQL */ `subscription OnCreateWorkTypePricing(
  $filter: ModelSubscriptionWorkTypePricingFilterInput
) {
  onCreateWorkTypePricing(filter: $filter) {
    id
    entityId
    workTypeGroupId
    body
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWorkTypePricingSubscriptionVariables,
  APITypes.OnCreateWorkTypePricingSubscription
>;
export const onUpdateWorkTypePricing = /* GraphQL */ `subscription OnUpdateWorkTypePricing(
  $filter: ModelSubscriptionWorkTypePricingFilterInput
) {
  onUpdateWorkTypePricing(filter: $filter) {
    id
    entityId
    workTypeGroupId
    body
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWorkTypePricingSubscriptionVariables,
  APITypes.OnUpdateWorkTypePricingSubscription
>;
export const onDeleteWorkTypePricing = /* GraphQL */ `subscription OnDeleteWorkTypePricing(
  $filter: ModelSubscriptionWorkTypePricingFilterInput
) {
  onDeleteWorkTypePricing(filter: $filter) {
    id
    entityId
    workTypeGroupId
    body
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWorkTypePricingSubscriptionVariables,
  APITypes.OnDeleteWorkTypePricingSubscription
>;
export const onCreateDefaultWorkTypePricing = /* GraphQL */ `subscription OnCreateDefaultWorkTypePricing(
  $filter: ModelSubscriptionDefaultWorkTypePricingFilterInput
) {
  onCreateDefaultWorkTypePricing(filter: $filter) {
    id
    unitCost
    unitPrice
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDefaultWorkTypePricingSubscriptionVariables,
  APITypes.OnCreateDefaultWorkTypePricingSubscription
>;
export const onUpdateDefaultWorkTypePricing = /* GraphQL */ `subscription OnUpdateDefaultWorkTypePricing(
  $filter: ModelSubscriptionDefaultWorkTypePricingFilterInput
) {
  onUpdateDefaultWorkTypePricing(filter: $filter) {
    id
    unitCost
    unitPrice
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDefaultWorkTypePricingSubscriptionVariables,
  APITypes.OnUpdateDefaultWorkTypePricingSubscription
>;
export const onDeleteDefaultWorkTypePricing = /* GraphQL */ `subscription OnDeleteDefaultWorkTypePricing(
  $filter: ModelSubscriptionDefaultWorkTypePricingFilterInput
) {
  onDeleteDefaultWorkTypePricing(filter: $filter) {
    id
    unitCost
    unitPrice
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDefaultWorkTypePricingSubscriptionVariables,
  APITypes.OnDeleteDefaultWorkTypePricingSubscription
>;
export const onCreateTemporaryWorkType = /* GraphQL */ `subscription OnCreateTemporaryWorkType(
  $filter: ModelSubscriptionTemporaryWorkTypeFilterInput
) {
  onCreateTemporaryWorkType(filter: $filter) {
    id
    workTypeGroupId
    environmentAgnosticWorkTypeGroupId
    body
    version
    schemaVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTemporaryWorkTypeSubscriptionVariables,
  APITypes.OnCreateTemporaryWorkTypeSubscription
>;
export const onUpdateTemporaryWorkType = /* GraphQL */ `subscription OnUpdateTemporaryWorkType(
  $filter: ModelSubscriptionTemporaryWorkTypeFilterInput
) {
  onUpdateTemporaryWorkType(filter: $filter) {
    id
    workTypeGroupId
    environmentAgnosticWorkTypeGroupId
    body
    version
    schemaVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTemporaryWorkTypeSubscriptionVariables,
  APITypes.OnUpdateTemporaryWorkTypeSubscription
>;
export const onDeleteTemporaryWorkType = /* GraphQL */ `subscription OnDeleteTemporaryWorkType(
  $filter: ModelSubscriptionTemporaryWorkTypeFilterInput
) {
  onDeleteTemporaryWorkType(filter: $filter) {
    id
    workTypeGroupId
    environmentAgnosticWorkTypeGroupId
    body
    version
    schemaVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemporaryWorkTypeSubscriptionVariables,
  APITypes.OnDeleteTemporaryWorkTypeSubscription
>;
export const onCreateTender = /* GraphQL */ `subscription OnCreateTender($filter: ModelSubscriptionTenderFilterInput) {
  onCreateTender(filter: $filter) {
    id
    solutionId
    status
    latestVersion
    awardedVersion
    projectNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTenderSubscriptionVariables,
  APITypes.OnCreateTenderSubscription
>;
export const onUpdateTender = /* GraphQL */ `subscription OnUpdateTender($filter: ModelSubscriptionTenderFilterInput) {
  onUpdateTender(filter: $filter) {
    id
    solutionId
    status
    latestVersion
    awardedVersion
    projectNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTenderSubscriptionVariables,
  APITypes.OnUpdateTenderSubscription
>;
export const onDeleteTender = /* GraphQL */ `subscription OnDeleteTender($filter: ModelSubscriptionTenderFilterInput) {
  onDeleteTender(filter: $filter) {
    id
    solutionId
    status
    latestVersion
    awardedVersion
    projectNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTenderSubscriptionVariables,
  APITypes.OnDeleteTenderSubscription
>;
export const onCreateTenderMinorVersion = /* GraphQL */ `subscription OnCreateTenderMinorVersion(
  $filter: ModelSubscriptionTenderMinorVersionFilterInput
) {
  onCreateTenderMinorVersion(filter: $filter) {
    id
    tenderId
    version
    solutionId
    solutionMinorVersion
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      __typename
    }
    contentKey
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTenderMinorVersionSubscriptionVariables,
  APITypes.OnCreateTenderMinorVersionSubscription
>;
export const onUpdateTenderMinorVersion = /* GraphQL */ `subscription OnUpdateTenderMinorVersion(
  $filter: ModelSubscriptionTenderMinorVersionFilterInput
) {
  onUpdateTenderMinorVersion(filter: $filter) {
    id
    tenderId
    version
    solutionId
    solutionMinorVersion
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      __typename
    }
    contentKey
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTenderMinorVersionSubscriptionVariables,
  APITypes.OnUpdateTenderMinorVersionSubscription
>;
export const onDeleteTenderMinorVersion = /* GraphQL */ `subscription OnDeleteTenderMinorVersion(
  $filter: ModelSubscriptionTenderMinorVersionFilterInput
) {
  onDeleteTenderMinorVersion(filter: $filter) {
    id
    tenderId
    version
    solutionId
    solutionMinorVersion
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      __typename
    }
    contentKey
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTenderMinorVersionSubscriptionVariables,
  APITypes.OnDeleteTenderMinorVersionSubscription
>;
export const onCreateTag = /* GraphQL */ `subscription OnCreateTag($filter: ModelSubscriptionTagFilterInput) {
  onCreateTag(filter: $filter) {
    id
    name
    createdBy
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTagSubscriptionVariables,
  APITypes.OnCreateTagSubscription
>;
export const onUpdateTag = /* GraphQL */ `subscription OnUpdateTag($filter: ModelSubscriptionTagFilterInput) {
  onUpdateTag(filter: $filter) {
    id
    name
    createdBy
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTagSubscriptionVariables,
  APITypes.OnUpdateTagSubscription
>;
export const onDeleteTag = /* GraphQL */ `subscription OnDeleteTag($filter: ModelSubscriptionTagFilterInput) {
  onDeleteTag(filter: $filter) {
    id
    name
    createdBy
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTagSubscriptionVariables,
  APITypes.OnDeleteTagSubscription
>;
export const onCreateUserOnboardingProgress = /* GraphQL */ `subscription OnCreateUserOnboardingProgress(
  $filter: ModelSubscriptionUserOnboardingProgressFilterInput
) {
  onCreateUserOnboardingProgress(filter: $filter) {
    id
    userId
    hasUserBeenAssociatedWithOrganization
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserOnboardingProgressSubscriptionVariables,
  APITypes.OnCreateUserOnboardingProgressSubscription
>;
export const onUpdateUserOnboardingProgress = /* GraphQL */ `subscription OnUpdateUserOnboardingProgress(
  $filter: ModelSubscriptionUserOnboardingProgressFilterInput
) {
  onUpdateUserOnboardingProgress(filter: $filter) {
    id
    userId
    hasUserBeenAssociatedWithOrganization
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserOnboardingProgressSubscriptionVariables,
  APITypes.OnUpdateUserOnboardingProgressSubscription
>;
export const onDeleteUserOnboardingProgress = /* GraphQL */ `subscription OnDeleteUserOnboardingProgress(
  $filter: ModelSubscriptionUserOnboardingProgressFilterInput
) {
  onDeleteUserOnboardingProgress(filter: $filter) {
    id
    userId
    hasUserBeenAssociatedWithOrganization
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserOnboardingProgressSubscriptionVariables,
  APITypes.OnDeleteUserOnboardingProgressSubscription
>;
export const onCreateTemplate = /* GraphQL */ `subscription OnCreateTemplate($filter: ModelSubscriptionTemplateFilterInput) {
  onCreateTemplate(filter: $filter) {
    id
    type
    name
    s3Key
    ownerId
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTemplateSubscriptionVariables,
  APITypes.OnCreateTemplateSubscription
>;
export const onUpdateTemplate = /* GraphQL */ `subscription OnUpdateTemplate($filter: ModelSubscriptionTemplateFilterInput) {
  onUpdateTemplate(filter: $filter) {
    id
    type
    name
    s3Key
    ownerId
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTemplateSubscriptionVariables,
  APITypes.OnUpdateTemplateSubscription
>;
export const onDeleteTemplate = /* GraphQL */ `subscription OnDeleteTemplate($filter: ModelSubscriptionTemplateFilterInput) {
  onDeleteTemplate(filter: $filter) {
    id
    type
    name
    s3Key
    ownerId
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemplateSubscriptionVariables,
  APITypes.OnDeleteTemplateSubscription
>;
export const onCreateTemporaryAuthorizationCode = /* GraphQL */ `subscription OnCreateTemporaryAuthorizationCode(
  $filter: ModelSubscriptionTemporaryAuthorizationCodeFilterInput
) {
  onCreateTemporaryAuthorizationCode(filter: $filter) {
    id
    code
    userId
    expiresAt
    createdAt
    ttl
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTemporaryAuthorizationCodeSubscriptionVariables,
  APITypes.OnCreateTemporaryAuthorizationCodeSubscription
>;
export const onUpdateTemporaryAuthorizationCode = /* GraphQL */ `subscription OnUpdateTemporaryAuthorizationCode(
  $filter: ModelSubscriptionTemporaryAuthorizationCodeFilterInput
) {
  onUpdateTemporaryAuthorizationCode(filter: $filter) {
    id
    code
    userId
    expiresAt
    createdAt
    ttl
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTemporaryAuthorizationCodeSubscriptionVariables,
  APITypes.OnUpdateTemporaryAuthorizationCodeSubscription
>;
export const onDeleteTemporaryAuthorizationCode = /* GraphQL */ `subscription OnDeleteTemporaryAuthorizationCode(
  $filter: ModelSubscriptionTemporaryAuthorizationCodeFilterInput
) {
  onDeleteTemporaryAuthorizationCode(filter: $filter) {
    id
    code
    userId
    expiresAt
    createdAt
    ttl
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemporaryAuthorizationCodeSubscriptionVariables,
  APITypes.OnDeleteTemporaryAuthorizationCodeSubscription
>;
export const onCreateLinkRegistry = /* GraphQL */ `subscription OnCreateLinkRegistry(
  $filter: ModelSubscriptionLinkRegistryFilterInput
) {
  onCreateLinkRegistry(filter: $filter) {
    id
    propertyId
    action
    variables
    published
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLinkRegistrySubscriptionVariables,
  APITypes.OnCreateLinkRegistrySubscription
>;
export const onUpdateLinkRegistry = /* GraphQL */ `subscription OnUpdateLinkRegistry(
  $filter: ModelSubscriptionLinkRegistryFilterInput
) {
  onUpdateLinkRegistry(filter: $filter) {
    id
    propertyId
    action
    variables
    published
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLinkRegistrySubscriptionVariables,
  APITypes.OnUpdateLinkRegistrySubscription
>;
export const onDeleteLinkRegistry = /* GraphQL */ `subscription OnDeleteLinkRegistry(
  $filter: ModelSubscriptionLinkRegistryFilterInput
) {
  onDeleteLinkRegistry(filter: $filter) {
    id
    propertyId
    action
    variables
    published
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLinkRegistrySubscriptionVariables,
  APITypes.OnDeleteLinkRegistrySubscription
>;
export const onCreateExternalReportBranding = /* GraphQL */ `subscription OnCreateExternalReportBranding(
  $filter: ModelSubscriptionExternalReportBrandingFilterInput
) {
  onCreateExternalReportBranding(filter: $filter) {
    id
    name
    logoKey
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateExternalReportBrandingSubscriptionVariables,
  APITypes.OnCreateExternalReportBrandingSubscription
>;
export const onUpdateExternalReportBranding = /* GraphQL */ `subscription OnUpdateExternalReportBranding(
  $filter: ModelSubscriptionExternalReportBrandingFilterInput
) {
  onUpdateExternalReportBranding(filter: $filter) {
    id
    name
    logoKey
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateExternalReportBrandingSubscriptionVariables,
  APITypes.OnUpdateExternalReportBrandingSubscription
>;
export const onDeleteExternalReportBranding = /* GraphQL */ `subscription OnDeleteExternalReportBranding(
  $filter: ModelSubscriptionExternalReportBrandingFilterInput
) {
  onDeleteExternalReportBranding(filter: $filter) {
    id
    name
    logoKey
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteExternalReportBrandingSubscriptionVariables,
  APITypes.OnDeleteExternalReportBrandingSubscription
>;
export const onCreateMeeting = /* GraphQL */ `subscription OnCreateMeeting($filter: ModelSubscriptionMeetingFilterInput) {
  onCreateMeeting(filter: $filter) {
    id
    status
    data
    createdBy
    mediaPipelineId
    recordingKey
    recordingAttachmentId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMeetingSubscriptionVariables,
  APITypes.OnCreateMeetingSubscription
>;
export const onUpdateMeeting = /* GraphQL */ `subscription OnUpdateMeeting($filter: ModelSubscriptionMeetingFilterInput) {
  onUpdateMeeting(filter: $filter) {
    id
    status
    data
    createdBy
    mediaPipelineId
    recordingKey
    recordingAttachmentId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMeetingSubscriptionVariables,
  APITypes.OnUpdateMeetingSubscription
>;
export const onDeleteMeeting = /* GraphQL */ `subscription OnDeleteMeeting($filter: ModelSubscriptionMeetingFilterInput) {
  onDeleteMeeting(filter: $filter) {
    id
    status
    data
    createdBy
    mediaPipelineId
    recordingKey
    recordingAttachmentId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMeetingSubscriptionVariables,
  APITypes.OnDeleteMeetingSubscription
>;
export const onCreateAttendee = /* GraphQL */ `subscription OnCreateAttendee($filter: ModelSubscriptionAttendeeFilterInput) {
  onCreateAttendee(filter: $filter) {
    id
    meetingId
    entityId
    name
    role
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAttendeeSubscriptionVariables,
  APITypes.OnCreateAttendeeSubscription
>;
export const onUpdateAttendee = /* GraphQL */ `subscription OnUpdateAttendee($filter: ModelSubscriptionAttendeeFilterInput) {
  onUpdateAttendee(filter: $filter) {
    id
    meetingId
    entityId
    name
    role
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAttendeeSubscriptionVariables,
  APITypes.OnUpdateAttendeeSubscription
>;
export const onDeleteAttendee = /* GraphQL */ `subscription OnDeleteAttendee($filter: ModelSubscriptionAttendeeFilterInput) {
  onDeleteAttendee(filter: $filter) {
    id
    meetingId
    entityId
    name
    role
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAttendeeSubscriptionVariables,
  APITypes.OnDeleteAttendeeSubscription
>;
export const onCreateCodeBuildJob = /* GraphQL */ `subscription OnCreateCodeBuildJob(
  $filter: ModelSubscriptionCodeBuildJobFilterInput
) {
  onCreateCodeBuildJob(filter: $filter) {
    id
    parentId
    projectName
    status
    artifactPath
    buildStartTime
    buildEndTime
    requestedBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCodeBuildJobSubscriptionVariables,
  APITypes.OnCreateCodeBuildJobSubscription
>;
export const onUpdateCodeBuildJob = /* GraphQL */ `subscription OnUpdateCodeBuildJob(
  $filter: ModelSubscriptionCodeBuildJobFilterInput
) {
  onUpdateCodeBuildJob(filter: $filter) {
    id
    parentId
    projectName
    status
    artifactPath
    buildStartTime
    buildEndTime
    requestedBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCodeBuildJobSubscriptionVariables,
  APITypes.OnUpdateCodeBuildJobSubscription
>;
export const onDeleteCodeBuildJob = /* GraphQL */ `subscription OnDeleteCodeBuildJob(
  $filter: ModelSubscriptionCodeBuildJobFilterInput
) {
  onDeleteCodeBuildJob(filter: $filter) {
    id
    parentId
    projectName
    status
    artifactPath
    buildStartTime
    buildEndTime
    requestedBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCodeBuildJobSubscriptionVariables,
  APITypes.OnDeleteCodeBuildJobSubscription
>;
export const onCreateResourceNotificationSetting = /* GraphQL */ `subscription OnCreateResourceNotificationSetting(
  $filter: ModelSubscriptionResourceNotificationSettingFilterInput
) {
  onCreateResourceNotificationSetting(filter: $filter) {
    resourceId
    resourceType
    notificationType
    recipients {
      recipientId
      recipientIdType
      notificationChannels
      enabled
      __typename
    }
    enabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateResourceNotificationSettingSubscriptionVariables,
  APITypes.OnCreateResourceNotificationSettingSubscription
>;
export const onUpdateResourceNotificationSetting = /* GraphQL */ `subscription OnUpdateResourceNotificationSetting(
  $filter: ModelSubscriptionResourceNotificationSettingFilterInput
) {
  onUpdateResourceNotificationSetting(filter: $filter) {
    resourceId
    resourceType
    notificationType
    recipients {
      recipientId
      recipientIdType
      notificationChannels
      enabled
      __typename
    }
    enabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateResourceNotificationSettingSubscriptionVariables,
  APITypes.OnUpdateResourceNotificationSettingSubscription
>;
export const onDeleteResourceNotificationSetting = /* GraphQL */ `subscription OnDeleteResourceNotificationSetting(
  $filter: ModelSubscriptionResourceNotificationSettingFilterInput
) {
  onDeleteResourceNotificationSetting(filter: $filter) {
    resourceId
    resourceType
    notificationType
    recipients {
      recipientId
      recipientIdType
      notificationChannels
      enabled
      __typename
    }
    enabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteResourceNotificationSettingSubscriptionVariables,
  APITypes.OnDeleteResourceNotificationSettingSubscription
>;
export const onCreateAssessmentSchedule = /* GraphQL */ `subscription OnCreateAssessmentSchedule(
  $filter: ModelSubscriptionAssessmentScheduleFilterInput
) {
  onCreateAssessmentSchedule(filter: $filter) {
    id
    propertyId
    name
    description
    startDate
    endDate
    recurrence {
      type
      dailyRecurrence {
        interval
        __typename
      }
      weeklyRecurrence {
        interval
        daysOfWeek
        __typename
      }
      monthlyRecurrence {
        type
        interval
        dayOfMonth
        nthWeekDay {
          weekNumber
          day
          __typename
        }
        __typename
      }
      __typename
    }
    authorizedIdentifiers
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessmentScheduleSubscriptionVariables,
  APITypes.OnCreateAssessmentScheduleSubscription
>;
export const onUpdateAssessmentSchedule = /* GraphQL */ `subscription OnUpdateAssessmentSchedule(
  $filter: ModelSubscriptionAssessmentScheduleFilterInput
) {
  onUpdateAssessmentSchedule(filter: $filter) {
    id
    propertyId
    name
    description
    startDate
    endDate
    recurrence {
      type
      dailyRecurrence {
        interval
        __typename
      }
      weeklyRecurrence {
        interval
        daysOfWeek
        __typename
      }
      monthlyRecurrence {
        type
        interval
        dayOfMonth
        nthWeekDay {
          weekNumber
          day
          __typename
        }
        __typename
      }
      __typename
    }
    authorizedIdentifiers
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAssessmentScheduleSubscriptionVariables,
  APITypes.OnUpdateAssessmentScheduleSubscription
>;
export const onDeleteAssessmentSchedule = /* GraphQL */ `subscription OnDeleteAssessmentSchedule(
  $filter: ModelSubscriptionAssessmentScheduleFilterInput
) {
  onDeleteAssessmentSchedule(filter: $filter) {
    id
    propertyId
    name
    description
    startDate
    endDate
    recurrence {
      type
      dailyRecurrence {
        interval
        __typename
      }
      weeklyRecurrence {
        interval
        daysOfWeek
        __typename
      }
      monthlyRecurrence {
        type
        interval
        dayOfMonth
        nthWeekDay {
          weekNumber
          day
          __typename
        }
        __typename
      }
      __typename
    }
    authorizedIdentifiers
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAssessmentScheduleSubscriptionVariables,
  APITypes.OnDeleteAssessmentScheduleSubscription
>;
export const onCreateResourceAssessmentScheduleAssociation = /* GraphQL */ `subscription OnCreateResourceAssessmentScheduleAssociation(
  $filter: ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput
) {
  onCreateResourceAssessmentScheduleAssociation(filter: $filter) {
    id
    assessmentScheduleId
    resourceId
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateResourceAssessmentScheduleAssociationSubscriptionVariables,
  APITypes.OnCreateResourceAssessmentScheduleAssociationSubscription
>;
export const onUpdateResourceAssessmentScheduleAssociation = /* GraphQL */ `subscription OnUpdateResourceAssessmentScheduleAssociation(
  $filter: ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput
) {
  onUpdateResourceAssessmentScheduleAssociation(filter: $filter) {
    id
    assessmentScheduleId
    resourceId
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateResourceAssessmentScheduleAssociationSubscriptionVariables,
  APITypes.OnUpdateResourceAssessmentScheduleAssociationSubscription
>;
export const onDeleteResourceAssessmentScheduleAssociation = /* GraphQL */ `subscription OnDeleteResourceAssessmentScheduleAssociation(
  $filter: ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput
) {
  onDeleteResourceAssessmentScheduleAssociation(filter: $filter) {
    id
    assessmentScheduleId
    resourceId
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteResourceAssessmentScheduleAssociationSubscriptionVariables,
  APITypes.OnDeleteResourceAssessmentScheduleAssociationSubscription
>;
export const onCreateAssessment = /* GraphQL */ `subscription OnCreateAssessment(
  $filter: ModelSubscriptionAssessmentFilterInput
) {
  onCreateAssessment(filter: $filter) {
    id
    scheduleId
    resourceId
    propertyId
    resourceType
    createdBy
    submittedBy {
      firstName
      lastName
      __typename
    }
    createdTime
    status
    issueIds
    tagIds
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessmentSubscriptionVariables,
  APITypes.OnCreateAssessmentSubscription
>;
export const onUpdateAssessment = /* GraphQL */ `subscription OnUpdateAssessment(
  $filter: ModelSubscriptionAssessmentFilterInput
) {
  onUpdateAssessment(filter: $filter) {
    id
    scheduleId
    resourceId
    propertyId
    resourceType
    createdBy
    submittedBy {
      firstName
      lastName
      __typename
    }
    createdTime
    status
    issueIds
    tagIds
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAssessmentSubscriptionVariables,
  APITypes.OnUpdateAssessmentSubscription
>;
export const onDeleteAssessment = /* GraphQL */ `subscription OnDeleteAssessment(
  $filter: ModelSubscriptionAssessmentFilterInput
) {
  onDeleteAssessment(filter: $filter) {
    id
    scheduleId
    resourceId
    propertyId
    resourceType
    createdBy
    submittedBy {
      firstName
      lastName
      __typename
    }
    createdTime
    status
    issueIds
    tagIds
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAssessmentSubscriptionVariables,
  APITypes.OnDeleteAssessmentSubscription
>;
export const onCreateProperty3PIntegrationConfiguration = /* GraphQL */ `subscription OnCreateProperty3PIntegrationConfiguration(
  $filter: ModelSubscriptionProperty3PIntegrationConfigurationFilterInput
) {
  onCreateProperty3PIntegrationConfiguration(filter: $filter) {
    id
    propertyId
    workflowEndpoint
    workflowName
    clientId
    clientSecret
    tokenUrl
    authorizeUrl
    scope
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProperty3PIntegrationConfigurationSubscriptionVariables,
  APITypes.OnCreateProperty3PIntegrationConfigurationSubscription
>;
export const onUpdateProperty3PIntegrationConfiguration = /* GraphQL */ `subscription OnUpdateProperty3PIntegrationConfiguration(
  $filter: ModelSubscriptionProperty3PIntegrationConfigurationFilterInput
) {
  onUpdateProperty3PIntegrationConfiguration(filter: $filter) {
    id
    propertyId
    workflowEndpoint
    workflowName
    clientId
    clientSecret
    tokenUrl
    authorizeUrl
    scope
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProperty3PIntegrationConfigurationSubscriptionVariables,
  APITypes.OnUpdateProperty3PIntegrationConfigurationSubscription
>;
export const onDeleteProperty3PIntegrationConfiguration = /* GraphQL */ `subscription OnDeleteProperty3PIntegrationConfiguration(
  $filter: ModelSubscriptionProperty3PIntegrationConfigurationFilterInput
) {
  onDeleteProperty3PIntegrationConfiguration(filter: $filter) {
    id
    propertyId
    workflowEndpoint
    workflowName
    clientId
    clientSecret
    tokenUrl
    authorizeUrl
    scope
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProperty3PIntegrationConfigurationSubscriptionVariables,
  APITypes.OnDeleteProperty3PIntegrationConfigurationSubscription
>;
export const onCreateConversationState = /* GraphQL */ `subscription OnCreateConversationState(
  $filter: ModelSubscriptionConversationStateFilterInput
) {
  onCreateConversationState(filter: $filter) {
    id
    attachments
    conversationType
    extractedDetails
    conversationStatus
    invokerId
    nextStep
    nextStepMessage
    userId
    externalConversationId
    phoneNumber
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateConversationStateSubscriptionVariables,
  APITypes.OnCreateConversationStateSubscription
>;
export const onUpdateConversationState = /* GraphQL */ `subscription OnUpdateConversationState(
  $filter: ModelSubscriptionConversationStateFilterInput
) {
  onUpdateConversationState(filter: $filter) {
    id
    attachments
    conversationType
    extractedDetails
    conversationStatus
    invokerId
    nextStep
    nextStepMessage
    userId
    externalConversationId
    phoneNumber
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateConversationStateSubscriptionVariables,
  APITypes.OnUpdateConversationStateSubscription
>;
export const onDeleteConversationState = /* GraphQL */ `subscription OnDeleteConversationState(
  $filter: ModelSubscriptionConversationStateFilterInput
) {
  onDeleteConversationState(filter: $filter) {
    id
    attachments
    conversationType
    extractedDetails
    conversationStatus
    invokerId
    nextStep
    nextStepMessage
    userId
    externalConversationId
    phoneNumber
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteConversationStateSubscriptionVariables,
  APITypes.OnDeleteConversationStateSubscription
>;
export const onCreatePolicyTemplateLink = /* GraphQL */ `subscription OnCreatePolicyTemplateLink(
  $filter: ModelSubscriptionPolicyTemplateLinkFilterInput
) {
  onCreatePolicyTemplateLink(filter: $filter) {
    id
    templateId
    entityId
    entityType
    resourceId
    resourceType
    grantedBy
    grantedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePolicyTemplateLinkSubscriptionVariables,
  APITypes.OnCreatePolicyTemplateLinkSubscription
>;
export const onUpdatePolicyTemplateLink = /* GraphQL */ `subscription OnUpdatePolicyTemplateLink(
  $filter: ModelSubscriptionPolicyTemplateLinkFilterInput
) {
  onUpdatePolicyTemplateLink(filter: $filter) {
    id
    templateId
    entityId
    entityType
    resourceId
    resourceType
    grantedBy
    grantedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePolicyTemplateLinkSubscriptionVariables,
  APITypes.OnUpdatePolicyTemplateLinkSubscription
>;
export const onDeletePolicyTemplateLink = /* GraphQL */ `subscription OnDeletePolicyTemplateLink(
  $filter: ModelSubscriptionPolicyTemplateLinkFilterInput
) {
  onDeletePolicyTemplateLink(filter: $filter) {
    id
    templateId
    entityId
    entityType
    resourceId
    resourceType
    grantedBy
    grantedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePolicyTemplateLinkSubscriptionVariables,
  APITypes.OnDeletePolicyTemplateLinkSubscription
>;
